/**
 * 渲染nagbar右按钮组
 */
import {supportNative, getErrorFactory, logError} from './util';

const zzc = window.zzc;


/**
 * 渲染“navbar”左侧按钮
 * doc: https://doc.oschina.net/tantucom?t=216536
 * @export
 * @param {object} options 配置参数
 * * type: 按钮类型（text, image, back_btn, switch_btn）
 * * imageUrl: image类型按钮的图片资源（内置：like, liked, share, edit, more, add）
 * * toImageUrl: 同imageUrl，当navbar隐藏时出现
 * @returns Promise.resolve(true)
 */
export default function renderNavbarLeftButton(options) {
  let errorFactory = getErrorFactory('renderNavbarLeftButton');

  if (!supportNative('base_customNavbarLeftButton')) {
    let err = errorFactory('不支持zzcjsbridge');
    return logError(err);
  }

  zzc.call('base_customNavbarLeftButton', {
    ...options,
    complete: function (res) {
      if (res.state) {
        logError(errorFactory(res.message));
      }
    }
  });
}



// WEBPACK FOOTER //
// ./src/native/renderNavbarLeftButton.js